const defaultOptions = {
  autoClose: 5000,
  className: 'toast-container',
  bodyClassName: 'tw-text-[14px]',
};

export default defaultOptions;
